import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarNavItem = _resolveComponent("SidebarNavItem")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/users",
      icon: "user",
      title: "Manage Users"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/user-products",
      icon: "database",
      title: "User Products"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/market-products",
      icon: "shop",
      title: "Market Products"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/alerts",
      icon: "bell",
      title: "Alerts"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/broker-groups",
      icon: "team",
      title: "Broker Groups"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bankwatch/notices",
      icon: "bell",
      title: "Platform Notices"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/bank-categories",
      icon: "tags",
      title: "Bank Categories"
    }),
    _createVNode(_component_SidebarNavItem, {
      to: "/product-blacklist",
      icon: "stop",
      title: "Product Blacklist"
    })
  ]))
}